// eslint-disable-next-line import/no-cycle
import bffApi, {BffResponse} from '@client/bffApi';
// eslint-disable-next-line import/no-cycle
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {CustodianService, WithdrawalIraConstraints, WithdrawalIraConstraintsOptions} from '@simpleinvest/ms-custodian-sdk';
import {AxiosResponse} from 'axios';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';
import {LiquidationRequest} from './request/ServiceRequest';
import {LiquidationResponse} from './response/ServiceResponse';

export default {
  getCustodianServiceInstance({logger = getLogger()} = {}): CustodianService {
    return new CustodianService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger,
    });
  },
  async getIraConstraints({
    accountId,
    withdrawalMechanism,
  }: WithdrawalIraConstraintsOptions): Promise<WithdrawalIraConstraints> {
    const service: CustodianService = await this.getCustodianServiceInstance();

    return service.getWithdrawalIraConstraints({
      accountId,
      withdrawalMechanism,
      withdrawalType: 'FULL_LIQUIDATION',
    });
  },
  async submitLiquidationRequest(
    liquidationData: LiquidationRequest
  ): Promise<AxiosResponse<BffResponse<LiquidationResponse>>> {
    const result = await bffApi
      .getAxiosInstance()
      .post<BffResponse<LiquidationResponse>>(
        `${bffApi.getBaseUrl(true)}/full-liquidations/submit-request`,
        liquidationData
      );

    return result;
  },
};
